/*************************************************/
/* NEWS                                          */
/*************************************************/

export function news($body, bodyLoadingClass) {
    let $newsContainer,
        $lazyLoadButton,
        $lazyLoadContainer,
        $newsListContainer,
        pageSize,
        totalSize,
        newsPageId,
        newsControllerUrl,
        itemsToSkip;

    const init = function () {
        $newsContainer = $(".news-section"),
            $lazyLoadButton = $newsContainer.find(".news-section__load-more"),
            $lazyLoadContainer = $lazyLoadButton.parent(".news-section__cta"),
            $newsListContainer = $newsContainer.find(".news-items"),
            pageSize = $newsContainer.data("newslist-pagesize"),
            totalSize = $newsContainer.data("newslist-totalsize"),
            newsPageId = $newsContainer.data("newspage-id"),
            newsControllerUrl = "/umbraco/surface/news/getnewslistpage",
            itemsToSkip = pageSize;

    }
    const lazyload = function () {
        // Lazyload
        $lazyLoadButton.click(function () {
            $body.addClass(bodyLoadingClass);
            $.get(newsControllerUrl,
                {
                    newsPageId: newsPageId,
                    itemsToSkip: itemsToSkip,
                    pageSize: pageSize
                }
            ).done(function (data) {
                if ($.trim(data)) {
                    $newsListContainer.append(data);
                    //Add page size to items to skip count
                    itemsToSkip += pageSize;
                    //If there are no more items to fetch, remove the button
                    if (itemsToSkip >= totalSize) {
                        $lazyLoadContainer.remove();
                    }
                } else {
                    console.log("Reponse was empty");
                }
            }).fail(function () {
                console.log("An error occured fetching the item page");
            }).always(function () {
                $body.removeClass(bodyLoadingClass);
            });
        });
    }
    init();
    lazyload();
}